export default function Brazil() {
    return (
        <img
            src="/assets/images/brazil.png"
            alt="Up and down png"
            className="lg:h-[28px] lg:w-[28px] h-[16px] w-[16px]"
        />
    );
}